import React from "react";
import { Paper, Stack, Text, Button } from "@mantine/core";
import { CustomText } from "./CustomText/CustomText";

const EmptyStateCard = ({
  icon,
  title,
  description,
  actionButton,
  className = "",
  ...props
}) => {
  return (
    <Paper
      withBorder
      p="xl"
      radius="md"
      className={`text-center bg-gray-50 ${className}`}
      {...props}
    >
      <Stack gap="md" align="center">
        {icon && <div className="text-gray-400">{icon}</div>}
        <div>
          <CustomText size="lg" fw={500} className="mb-1">
            {title}
          </CustomText>
          <CustomText size="sm" c="dimmed">
            {description}
          </CustomText>
        </div>
        {actionButton && actionButton}
      </Stack>
    </Paper>
  );
};

export default EmptyStateCard;
